import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import AdminForm from "./pages/AdminForm";
import Form from "./pages/Form";
import PrivateRoute from "./utils/PrivateRoute";
import Upload from "./pages/Upload";
import Thankyou from "./pages/Thankyou";
import Success from "./pages/Success";
import NotFound from "./pages/NotFound";
import TemplateUploadLogin from "./pages/NewLoginPage/TemplateUploadLogin";
import TemplateUploadForm from "./pages/TemplateUploadForm";
import NewLoginPage from "./pages/NewLoginPage/Index";
import LoginTest from "./pages/NewLoginPage/loginTest";
const Router: React.FC = () => {




  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        {/* <Route path="/new-login" element={<NewLoginPage />} /> */}

        {/* <Route
          path="/new-login"
          element={
            <NewLoginPage
            />
          }
        /> */}
        

        <Route path="/login/:mobile" element={<NewLoginPage />} />
        <Route path="/login" element={<NewLoginPage />} />
        <Route path="/signin" element={<LoginTest />} />
        {/* <Route path="/sign-in/:data" element={<TemplateUploadLogin />} /> */}
        <Route path="/sign-in/form" element={<TemplateUploadForm />} />
        <Route
          path="/form"
          element={
            <PrivateRoute>
              <Form />
            </PrivateRoute>
          }
        />
        <Route
          path="/upload"
          element={
            <PrivateRoute>
              <Upload />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-form"
          element={
            <PrivateRoute>
              <AdminForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/thank-you"
          element={
            <PrivateRoute>
              <Thankyou />
            </PrivateRoute>
          }
        />
        <Route
          path="/success"
          element={
              <Success />
          }
        />
        {/* <Route
      path="*"
      element={
        <PrivateRoute>
          <NotFound />
        </PrivateRoute>
      }
    /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
